export const enum EnumTelaIdentificacao {
    CpfCnpj = 1,
    Nome = 2,
    Telefone = 4,
    DataNascimento = 8,
    Sexo = 16,
    Todos = 17,
}